import {Row, Col} from 'react-bootstrap'
import KeyMenu from 'comps/KeyMenu.js'
const WelcomePage =(props) => {
    return (
        <Row>
            <Col xs={12} className="text-center" style={{marginTop: '20vh'}}>
                <h5 className="mb-5">Welcome to Wahlstedt Sageryd API documentation site</h5>
                <p>Please enter an API key to gain access.</p>
            </Col>
            <Col xs={12} className="pt-0 pb-5">
                <div style={{maxWidth: 700, margin: 'auto'}}>
                    <KeyMenu mode="input" hideDeleteBtn={true} />
                </div>
            </Col>
        </Row>
    )
}
export default WelcomePage